import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=75a1e5f5&"
import script from "./Terminos.js?vue&type=script&lang=js&"
export * from "./Terminos.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports